
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const closeMobileMenu = (e) => {
      const mobileMenu = document.getElementById('mobile-menu');
      const mobileToggle = document.getElementById('mobile-toggle');
      if (mobileMenu && mobileToggle && !mobileToggle.contains(e.target) && !mobileMenu.contains(e.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', closeMobileMenu);

    return () => {
      document.removeEventListener('click', closeMobileMenu);
    };
  }, []);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="hidden lg:block py-2 border-b border-gray-200">
          <nav>
            <ul className="flex items-center justify-center space-x-6 text-sm">
              <li><Link to="/jobs" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">All Jobs</Link></li>
              <li><Link to="/organizations" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Top Organizations</Link></li>
              <li><Link to="/government" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Government Jobs</Link></li>
              <li><Link to="/categories?cat=hospital" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Hospital Jobs</Link></li>
              <li><Link to="/categories?cat=hotel&location=dubai" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Hotel Jobs in Dubai</Link></li>
              <li><Link to="/categories?cat=supermarket" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Supermarket Jobs</Link></li>
              <li><Link to="/categories?cat=airport" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Airport Jobs</Link></li>
              <li><Link to="/categories?cat=banking" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Banking Jobs</Link></li>
              <li><Link to="/categories?cat=newspaper" className="text-gray-600 hover:text-primary-600 transition-colors duration-200">Newspaper Jobs</Link></li>
            </ul>
          </nav>
        </div>

        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex-shrink-0">
            <img src="/logo.png" alt="JobsDriver Logo" className="h-12 w-auto" onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://images.unsplash.com/photo-1611224923853-80b023f02d71?auto=format&fit=crop&w=200&h=80&q=80";
            }} />
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">Home</Link>
            <Link to="/jobs" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">All Jobs</Link>
            <Link to="/categories" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">Categories</Link>
            <Link to="/organizations" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">Top Organizations</Link>
            <Link to="/government" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">Government Jobs</Link>
            <Link to="/about" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">About Us</Link>
            <Link to="/contact" className="text-gray-700 hover:text-primary-600 font-medium transition-colors duration-200">Contact</Link>

          </nav>

          <button className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200" id="mobile-toggle" aria-label="Toggle Menu" onClick={toggleMobileMenu}>
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-gray-600`}></i>
          </button>
        </div>

        <div className={`lg:hidden ${isMobileMenuOpen ? '' : 'hidden'} bg-white border-t border-gray-200`} id="mobile-menu">
          <nav className="py-4 space-y-2">
            <Link to="/" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">Home</Link>
            <Link to="/jobs" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">All Jobs</Link>
            <Link to="/categories" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">Categories</Link>
            <Link to="/organizations" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">Top Organizations</Link>
            <Link to="/government" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">Government Jobs</Link>
            <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">About Us</Link>
            <Link to="/contact" className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-primary-600 transition-colors duration-200">Contact</Link>

          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
